export enum ChatFeedbackType {
  LIKE = 'LIKE',
  DISLIKE = 'DISLIKE',
}
